<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import fallbackLogo from '../../../design-system/images/logo-thumbnail.svg';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
    class="object-contain"
  />
  <img
    v-else
    v-bind="attrs"
    :src="fallbackLogo"
    alt="Lumeratec"
    class="object-contain"
  />
</template>
